<template>
    <div>
        <!-- ヘッダー -->
        <div class="mb-4">
            <h2 class="fw-bold text-info mb-1">
                <i class="fa-solid fa-bars"></i>
                メニューマスタ
            </h2>
        </div>
        <div class="container" v-cloak>
            <div class="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <button class="btn btn-outline-success btn-sm" @click="saveSort()" v-if="isSorted">
                        <i class="fa-solid fa-check"></i>
                        並び替え確定
                    </button>
                    <button class="btn btn-outline-secondary btn-sm" @click="reload()" v-if="isSorted">
                        <i class="fa-solid fa-check"></i>
                        並び替えキャンセル
                    </button>
                </div>
                <div>
                    <button class="btn btn-outline-primary" @click="editMenu()" :disabled="isSorted">
                        <span class="fa-solid fa-plus"></span> 
                        新規作成
                    </button>
                </div>
            </div>
            <div v-for="m in menus" :key="m.id" class="card mb-3">
                <div class="card-body d-flex justify-content-between align-items-center">
                    <div class="d-flex align-items-center gap-2">
                        <button class="btn btn-outline-secondary me-2" @click="editMenu(m.id)" :disabled="isSorted">
                            <span class="fa-solid fa-pencil"></span>
                        </button>
                        <button class="btn btn-outline-secondary me-2" @click="showSort(m)">
                            <i class="fa-solid fa-sort"></i>
                        </button>
                        <div>
                            <div class="flex-grow-1" :class="{
                                'fs-4 fw-bold': !m.path,
                                'fs-5': m.path,
                            }">{{ m.name }}</div>
                            <div class="small" v-if="m.path">
                                {{ m.path }}
                            </div>
                        </div>
                    </div>
                    <div>
                        <button class="btn btn-danger ms-2" @click="destroy(m)" :disabled="isSorted">
                            <span class="fa-solid fa-xmark"></span> 抹消
                        </button>
                    </div>
                </div>
            </div>
    
            <!-- 編集モーダル -->
            <menus-editor
                :menu_id="menu_id"
                @saved="reload"
                @close="closeModal"
            />
            <sort
                :selected="menu"
                :records="menus"
                name="name"
                header="!path"
                @close="closeModal"
                @moveTo="moveTo"></sort>
        </div>
    </div>
</template>

<script>
import MenusEditor from './menusEditor.vue'
import sort from "components/sort.vue";
export default {
    components: { 
        MenusEditor,
        sort
    },
    data() {
        return {
            menus: [],
            menu: {},       // 並び替え用
            menu_id: null,  // 編集用
            modals: [],     // モーダルウィンドウ
        }
    },
    methods: {
        reload() {
            axios.get('/api/admin/menus').then(res => {
                this.menus = res.data
            }).catch(err => {Alert.err(err)});
        },
        editMenu(id = null) {
            this.menu_id = id;
            setTimeout(() => {
                this.modals['menu-editor'].show();
            });
        },
        closeModal(id) {
            this.modals[id]?.hide();
        },
        destroy(menu) {
            swal({
                title: "メニュー抹消",
                text: "このメニューを抹消します。よろしいですか？",
                icon: "warning",
                buttons: ["キャンセル", "抹消"],
                dangerMode: true,
            }).then(confirm => {
                if (confirm) {
                    axios.delete(`/api/admin/menus/${menu.id}`).then(res => {
                        Alert.msg("メニューを抹消しました。");
                        this.reload();
                    }).catch(err => {Alert.err(err)});
                }
            })
        },
        showSort(v) {
            this.menu = v;
            setTimeout(() => {this.modals['sort-modal'].show()});
        },
        moveTo(to_id) {
            const from = _.findIndex(this.menus, {id: this.menu.id});
            const dest = _.findIndex(this.menus, {id: to_id});
            this.menus.splice(from, 1);
            const to = _.findIndex(this.menus, {id: to_id});
            if (from < dest) {
                // 下へ
                this.menus.splice(to + 1, 0, this.menu);
            } else {
                // 上へ
                this.menus.splice(to, 0, this.menu);
            }
        },
        saveSort() {
            axios.post("/api/admin/menus/sort", {menus: this.menus}).then(res => {
                Alert.msg(res.data);
                location.reload();
            }).catch(err => {
                Alert.err(err.response);
            }).finally(() => this.reload());
        },
    },
    computed: {
        isSorted() {
            let order_number = 1;
            for (let i = 0; i < this.menus.length; i++) {
                if (this.menus[i].order_number != order_number) {
                    return true;
                }
                order_number++;
            }
            return false;
        },
    },
    mounted() {
        this.modals['menu-editor'] = new bootstrap.Modal(document.getElementById('menu-editor'));
        this.modals['sort-modal'] = new bootstrap.Modal(document.getElementById('sort-modal'));
        this.reload();
    }
}
</script>
